const guia = {
  hero: {
    badge: 'Marktinformationen',
    title1: 'Preisführer nach',
    title2: ' Stadtteil und Stadt 2025',
    description: 'Verstehen Sie die lokalen Marktwerte mit Durchschnittspreisen pro m² / sq ft, jährlichen Trends und Stadtteilbewertungen in Miami (Florida, USA), São Paulo und Brasília.',
    statCities: '3 Städte',
    statNeighborhoods: '20 Stadtteile',
    statTrends: '5-Jahres-Trends',
    statAi: 'KI-generierte Daten',
  },
  pulse: {
    title: 'Marktpuls',
    subtitle: '3 Märkte · Neueste Updates',
    updated: 'Aktualisiert am',
    viewGuide: 'Guide ansehen',
    recentUpdates: 'aktuelle Updates',
    badgePrices: 'Preise',
    badgeTrend: 'Trend',
    disclaimer: '<0>Nur zu Bildungszwecken — Hinweis zu KI-generierten Daten:</0> Die auf dieser Seite dargestellten Durchschnittspreise pro m² / sq ft, jährlichen Wachstumsraten und Stadtteilbewertungen sind KI-generierte Schätzungen, die aus öffentlich zugänglichen Marktberichten, Immobilienindizes (FipeZAP, ZAP Imóveis, CondoBlackBook) und Drittquellen von 2024–2025 zusammengestellt wurden. Diese Daten können veraltet, unvollständig oder ungenau sein. Sie dienen ausschließlich allgemeinen Bildungs- und Informationszwecken und stellen keine Finanz-, Anlage- oder Immobilienberatung dar. <1>Carvalho\'s Imobiliária übernimmt keine Haftung für Fehler, Auslassungen oder Entscheidungen, die auf der Grundlage dieser Informationen getroffen werden.</1> Konsultieren Sie stets einen zugelassenen Immobilienfachmann und führen Sie eine unabhängige Due Diligence durch, bevor Sie eine Anlageentscheidung treffen.',
  },
  citySelector: {
    title: 'Stadt auswählen',
    subtitle: 'Klicken Sie, um Stadtteile und Preisdaten zu erkunden',
    selected: 'Ausgewählt',
    listings: 'Angebote',
    avgPrice: 'Durchschn. Preis',
    yoyGrowth: 'Jährl. Wachstum',
    viewFullGuide: 'Vollständigen Guide ansehen für',
  },
  miamiDetail: {
    description: 'Miami ist einer der dynamischsten Luxusimmobilienmärkte der Welt und zieht internationale Investoren und vermögende Käufer an. Die Stadt verbindet tropischen Lebensstil, Weltklasse-Annehmlichkeiten und starkes Wertsteigerungspotenzial. Im Jahr 2025 überschritten die Preise für Luxus-Eigentumswohnungen erstmals in der Geschichte durchschnittlich 1.000 $/sq ft.',
    avgPrice: 'Durchschn. Preis',
    yoyGrowth: 'Jährl. Wachstum',
    neighborhoods: 'Stadtteile',
    activeListings: 'Aktive Angebote',
    priceEvolution: 'Durchschnittliche Preisentwicklung',
    since2020: '+54,5 % seit 2020',
    currentAvg: 'Aktueller Durchschn. (2025)',
    neighborhoodsTitle: 'Stadtteile in Miami',
    neighborhoodsFound: '7 Stadtteile gefunden',
    searchPlaceholder: 'Stadtteile suchen...',
    sortPrice: 'Preis',
    sortGrowth: 'Wachstum',
    sortAZ: 'A–Z',
    pricePerSqft: 'Durchschn. Preis pro sq ft',
    yoyVar: 'Jährl. Veränd.',
    walkability: 'Fußgängerfreundlichkeit',
    infrastructure: 'Infrastruktur',
    appreciation: 'Wertsteigerung',
    viewFullGuide: 'Vollständigen Guide ansehen',
  },
  priceTable: {
    title: 'Vollständiger Preisvergleich',
    subtitle: 'Alle Stadtteile, sortiert nach Durchschnittspreis pro Einheit',
    colNeighborhood: 'Stadtteil',
    colCity: 'Stadt',
    colAvgPrice: 'Durchschn. Preis',
    colYoY: 'Jährl. Veränd.',
    colMarketType: 'Markttyp',
    colListings: 'Angebote',
  },
  compare: {
    title: 'Interaktives Tool',
    subtitle: 'Vergleichen Sie Märkte nebeneinander',
    description: 'Wählen Sie zwei Märkte aus und vergleichen Sie Preise, Rendite, Investitionsbewertungen und ideales Profil.',
    marketA: 'Markt A',
    marketB: 'Markt B',
    metric: 'Metrik',
    overview: 'Übersicht',
    returnYield: 'Rendite',
    investmentScores: 'Investitionsbewertung (0–10)',
    overallScore: 'Gesamtbewertung',
    profileAnalysis: 'Profil & Analyse',
    strengths: 'Stärken',
    risks: 'Hauptrisiken',
    viewAnalysis: 'Vollständige Stadtteilanalyse ansehen',
    viewMiamiGuide: 'Miami-Guide ansehen',
    viewSPGuide: 'São Paulo-Guide ansehen',
    footerNote: 'Die Bewertungen sind redaktionelle Schätzungen auf der Grundlage öffentlicher Indizes (FipeZAP, Zillow, Q1 2025). Sie stellen keine Finanzberatung dar.',
    of10: 'von 10',
    currency: 'Währung',
    entryPrice: 'Einstiegspreis (min.)',
    avgPrice: 'Durchschnittspreis',
    topMarket: 'Marktspitze',
    yoyAppreciation: 'Jährliche Wertsteigerung',
    rentalYield: 'Mietrendite',
    recommendedHorizon: 'Empfohlener Horizont',
    marketLiquidity: 'Marktliquidität',
    appreciationPotential: 'Wertsteigerungspotenzial',
    passiveIncome: 'Passives Einkommen',
    idealProfile: 'Ideales Anlegerprofil',
    locationMiami: 'Florida, USA',
    locationSP: 'São Paulo, Brasilien',
    currencyA: 'USD · US-Dollar',
    currencyB: 'BRL · Brasilianischer Real',
    yieldA: '5–8% p.a.',
    yieldB: '4–6% p.a.',
    horizonA: '5–10 Jahre',
    horizonB: '3–10 Jahre',
    idealProfileA: 'Internationale Diversifizierung, Währungsschutz und langfristiger Horizont (5–10 Jahre)',
    idealProfileB: 'Maximale Liquidität, Stadtteilvielfalt und Zugang zum größten Finanzzentrum Lateinamerikas',
    strengthsA: ['0% FL-Landeseinkommensteuer', 'Kurzzeitvermietung möglich', 'Internationaler Markt', 'Währungsabsicherung BRL/USD', 'Kumulierte Wertsteigerung +54% (5 Jahre)'],
    strengthsB: ['Größter Markt in LATAM', 'Maximale Liquidität', 'Vielfalt an Stadtteilen und Preisklassen', 'Faria-Lima-Unternehmenszentrum'],
    risksA: ['Währungsrisiko (BRL/USD)', 'Hohe Instandhaltungskosten', 'Pflichtversicherungen (Hurrikane)', 'Bürokratie für Nichtansässige'],
    risksB: ['ITBI + hohe Steuerlast', 'Hohes Angebot in einigen Stadtteilen', 'Allmählichere Wertsteigerung'],
  },
  country: {
    usa: 'USA',
    brazil: 'Brasilien',
  },
  cta: {
    title: 'Bereit, im richtigen Stadtteil zu investieren?',
    specialist: 'Spezialist für Marktinformationen',
    description: 'Unsere Spezialisten kennen jeden Markt in- und auswendig. Erhalten Sie noch heute eine persönliche Beratung.',
    whatsapp: 'Mit einem Experten auf WhatsApp sprechen',
    browse: 'Alle Angebote ansehen',
  },
  spHighlight: {
    title: 'Itaim Bibi führt die Wertsteigerung in SP mit +11,3 % im Jahresvergleich in Q1 2026 an',
    subtitle: 'Der Faria-Lima-Korridor hält die Nachfrage mit neuen Büros internationaler Fonds in der Region aufrecht.',
  },
  brasiliaHighlight: {
    title: 'FipeZAP: DF führt die Wertsteigerung unter den Hauptstädten mit +12,6 % im Jahr 2025 an',
    subtitle: 'Sudoeste und Noroeste treiben den Anstieg — der Durchschnittspreis in Plano Piloto erreicht R$14.300/m².',
  },
  miamiHighlight: {
    title: 'Sunny Isles überschreitet erstmals in der Geschichte 2.000 $/sq ft',
    subtitle: 'Bentley Residences und Porsche Design Tower heben das Preisniveau der Region auf ein Rekordhoch.',
  },
  cityPages: {
    shared: {
      marketPulse: 'Market Pulse',
      updates: '3 Aktualisierungen',
      updatedOn: 'Aktualisiert am',
      disclaimerWarning: 'Hinweis',
      disclaimerMiami: 'Preisdaten sind Schätzungen auf Basis öffentlicher Indizes (CondoBlackBook, Zillow, Q1 2025). Sie stellen keine Finanzberatung dar. Konsultieren Sie einen Fachmann, bevor Sie eine Anlageentscheidung treffen.',
      disclaimerBR: 'Preisdaten sind Schätzungen auf Basis öffentlicher Indizes (FipeZAP, ZAP Imóveis, 2025). Sie stellen keine Finanzberatung dar. Konsultieren Sie einen Fachmann, bevor Sie eine Anlageentscheidung treffen.',
      interactiveTool: 'Interaktives Tool',
      compareHeading: 'Märkte nebeneinander vergleichen',
      compareSubtitle: 'Wählen Sie zwei Märkte und vergleichen Sie Preise, Rendite, Investitionsbewertungen und ideales Profil.',
      marketA: 'Markt A',
      marketB: 'Markt B',
      vs: 'VS',
      metric: 'Metrik',
      overview: 'Übersicht',
      returnYield: 'Rendite',
      investmentScores: 'Investitionsbewertung (0–10)',
      overallScore: 'Gesamtbewertung',
      profileAnalysis: 'Profil & Analyse',
      idealProfile: 'Ideales Anlegerprofil',
      strengths: 'Stärken',
      risks: 'Hauptrisiken',
      viewAnalysis: 'Vollständige Stadtteilanalyse ansehen',
      footerNote: 'Bewertungen sind redaktionelle Schätzungen auf Basis öffentlicher Indizes (FipeZAP, Zillow, Q1 2025). Sie stellen keine Finanzberatung dar.',
      of10: 'von 10',
      currency: 'Währung',
      entryPrice: 'Einstiegspreis (min.)',
      avgPrice: 'Durchschnittspreis',
      topMarket: 'Marktspitze',
      yoyAppreciation: 'Jährliche Wertsteigerung',
      rentalYield: 'Mietrendite',
      recommendedHorizon: 'Empfohlener Horizont',
      marketLiquidity: 'Marktliquidität',
      appreciationPotential: 'Wertsteigerungspotenzial',
      passiveIncome: 'Passives Einkommen',
      faqBadge: 'Häufige Fragen',
      viewAllFaqs: 'Alle Fragen im FAQ-Center ansehen',
      exploreBadge: 'Market Guide',
      exploreTitle: 'Weitere Märkte erkunden',
      exploreSubtitle: 'Detaillierte Analyse der wichtigsten Immobilieninvestitionsziele.',
      exploreViewAll: 'Alle Märkte ansehen',
      avgPriceLabel: 'Durchschnittspreis',
      yoyLabel: 'Jährliche Wertsteigerung',
      viewFullGuide: 'Vollständigen Guide ansehen',
      colRank: '#',
      colNeighborhood: 'Stadtteil',
      colPrice: 'Durchschn. Preis',
      colYoY: 'Jährl. Veränd.',
      colProfile: 'Profil',
      colListings: 'Angebote',
      hot: 'Hot',
      top: 'Top',
      currencyLabel: 'Währung',
      ctaWhatsapp: 'Jetzt mit Experten sprechen',
      falarConsultor: 'Mit Berater sprechen',
    },
    miami: {
      heroBadge: 'Miami · Florida',
      heroTitle: 'Beste Stadtteile in Miami',
      heroTitleHighlight: 'zum Investieren 2025',
      heroDescription: 'Miami hat sich als Top-Immobilieninvestitionsziel für Brasilianer in den USA etabliert. Mit Durchschnittspreisen über 1.000 $/sq ft, historischer zweistelliger Wertsteigerung und ohne staatliche Einkommensteuer bietet die Stadt eine der besten risikobereinigten Renditen weltweit.',
      heroCtaProperties: 'Immobilien in Miami ansehen',
      heroCtaContact: 'Mit Berater sprechen',
      location: 'Miami, FL',
      countryLabel: 'Florida, USA',
      currencyA: 'USD · US-Dollar',
      currencyB: 'BRL · Brasilianischer Real',
      strengthsA: ['0% FL-Landeseinkommensteuer', 'Kurzzeitvermietung möglich', 'Internationaler Markt', 'Währungsabsicherung BRL/USD', 'Kumulierte Wertsteigerung +54% (5 Jahre)'],
      strengthsB: ['Größter Markt in LATAM', 'Maximale Liquidität', 'Stadtteil- und Preisklassenvielfalt', 'Faria-Lima-Unternehmenszentrum'],
      risksA: ['Währungsrisiko (BRL/USD)', 'Hohe Instandhaltungskosten', 'Pflichtversicherungen (Hurrikane)', 'Bürokratie für Nichtansässige'],
      risksB: ['ITBI + hohe Steuerlast', 'Hohes Angebot in einigen Gebieten', 'Allmählichere Wertsteigerung'],
      idealProfileA: 'Internationale Diversifizierung, Währungsschutz und langfristiger Horizont (5–10 Jahre)',
      idealProfileB: 'Maximale Liquidität, Stadtteilvielfalt und Zugang zum größten Finanzzentrum Lateinamerikas',
      entryPriceA: 'US$ 400.000',
      entryPriceB: 'R$ 350.000',
      avgPriceA: 'US$ 1.100/sq ft',
      avgPriceB: 'R$ 11.800/m²',
      topMarketA: 'US$ 3.800/sq ft · Bal Harbour',
      topMarketB: 'R$ 32.000/m² · Cidade Jardim',
      yieldA: '5–8% p.a.',
      yieldB: '4–6% p.a.',
      horizonA: '5–10 Jahre',
      horizonB: '3–10 Jahre',
      liquidityA: '9.2',
      liquidityB: '10.0',
      appreciationA: '9.0',
      appreciationB: '7.0',
      passiveIncomeA: '8.0',
      passiveIncomeB: '7.0',
      overallScoreA: '8.7',
      overallScoreB: '8.0',
      scoreWidthA: '87%',
      scoreWidthB: '80%',
      viewGuideA: 'Miami-Guide ansehen',
      viewGuideB: 'São Paulo-Guide ansehen',
      whyInvestTitle: 'Warum in Miami investieren?',
      whyInvestSubtitle: '4 Gründe, die Miami zum Top-Immobilieninvestitionsziel für Brasilianer in den USA machen.',
      neighborhoodsTitle: 'Miami Stadtteile — Vollständige Analyse',
      neighborhoodsSubtitle: 'Klicken Sie auf einen Stadtteil, um detaillierte Preise, Bewertungen und Markthighlights zu sehen.',
      rankingTitle: 'Preisranking — Miami Stadtteile',
      rankingSubtitle: 'Vergleich sortiert nach Durchschnittspreis pro sq ft · Q1 2025',
      howToBuyBadge: 'Leitfaden für Brasilianer',
      howToBuyTitle: 'Wie man als Brasilianer eine Immobilie in Miami kauft',
      howToBuySubtitle: 'Schritt-für-Schritt-Anleitung für brasilianische Investoren zum Erwerb von US-Immobilien mit Rechtssicherheit und Steuereffizienz.',
      howToBuyHelpTitle: 'Brauchen Sie Hilfe bei diesem ganzen Prozess?',
      howToBuyHelpSubtitle: 'Unser Team begleitet Brasilianer von der ITIN bis zur Schlüsselübergabe — ohne zusätzliche Kosten.',
      howToBuyHelpCTA: 'Mit Spezialist sprechen',
      faqTitle: 'Fragen zur Investition in Miami',
      faqSubtitle: 'Die wichtigsten Fragen brasilianischer Investoren zum Immobilienkauf in Miami — beantwortet von Spezialisten.',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Bundeshauptstadt mit dem höchsten Pro-Kopf-Einkommen Brasiliens, UNESCO-Weltkulturerbe und resilientem Markt.',
      exploreCardBrasiliaBadge: 'Bundesdistrikt',
      exploreCardBrasiliaPrice: 'R$12.000/m²',
      exploreCardBrasiliaYoY: '+12,6%',
      exploreCardBrasiliaYoYLabel: 'Höchster Anstieg des Jahres',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Größter Immobilienmarkt Lateinamerikas. Faria Lima, Itaim Bibi und der kontinuierliche Wertsteigerungskorridor.',
      exploreCardSPBadge: 'São Paulo, Brasilien',
      exploreCardSPPrice: 'R$11.800/m²',
      exploreCardSPYoY: '+8,7%',
      exploreCardSPYoYLabel: 'Jährliche Wertsteigerung',
      ctaTitle: 'Bereit, in Miami zu investieren?',
      ctaSubtitle: 'Unser auf Miami-Immobilien spezialisiertes Team betreut Brasilianer seit über 9 Jahren. Von der ITIN bis zur Schlüsselübergabe.',
      ctaSecondary: 'Immobilien in Miami ansehen',
    },
    saoPaulo: {
      heroBadge: 'São Paulo · SP',
      heroTitle: 'Beste Stadtteile in São Paulo',
      heroTitleHighlight: 'zum Investieren 2025',
      heroDescription: 'São Paulo ist die Finanzhauptstadt Brasiliens und der größte Immobilienmarkt Lateinamerikas. Mit über 12 Millionen Einwohnern, einem BIP, das dem ganzer Länder entspricht, und einer durchschnittlichen Wertsteigerung von +8,7% im Jahr 2025 bietet die Stadt einzigartige Chancen für Investoren, die Einkommen, Wertsteigerung oder Portfoliodiversifizierung suchen.',
      heroCtaProperties: 'Immobilien in São Paulo ansehen',
      heroCtaContact: 'Mit Berater sprechen',
      location: 'São Paulo, SP',
      countryLabel: 'São Paulo, Brasilien',
      currencyA: 'BRL · Brasilianischer Real',
      currencyB: 'USD · US-Dollar',
      strengthsA: ['Größter Markt in LATAM', 'Maximale Liquidität', 'Stadtteil- und Preisklassenvielfalt', 'Faria-Lima-Unternehmenszentrum'],
      strengthsB: ['0% FL-Landeseinkommensteuer', 'Kurzzeitvermietung möglich', 'Internationaler Markt', 'Währungsabsicherung BRL/USD', 'Kumulierte Wertsteigerung +54% (5 Jahre)'],
      risksA: ['ITBI + hohe Steuerlast', 'Hohes Angebot in einigen Gebieten', 'Allmählichere Wertsteigerung'],
      risksB: ['Währungsrisiko (BRL/USD)', 'Hohe Instandhaltungskosten', 'Pflichtversicherungen (Hurrikane)', 'Bürokratie für Nichtansässige'],
      idealProfileA: 'Maximale Liquidität, Stadtteilvielfalt und Zugang zum größten Finanzzentrum Lateinamerikas',
      idealProfileB: 'Internationale Diversifizierung, Währungsschutz und langfristiger Horizont (5–10 Jahre)',
      entryPriceA: 'R$ 350.000',
      entryPriceB: 'US$ 400.000',
      avgPriceA: 'R$ 11.800/m²',
      avgPriceB: 'US$ 1.100/sq ft',
      topMarketA: 'R$ 32.000/m² · Cidade Jardim',
      topMarketB: 'US$ 3.800/sq ft · Bal Harbour',
      yieldA: '4–6% p.a.',
      yieldB: '5–8% p.a.',
      horizonA: '3–10 Jahre',
      horizonB: '5–10 Jahre',
      liquidityA: '10.0',
      liquidityB: '9.2',
      appreciationA: '7.0',
      appreciationB: '9.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '8.0',
      overallScoreA: '8.0',
      overallScoreB: '8.7',
      scoreWidthA: '80%',
      scoreWidthB: '87%',
      viewGuideA: 'São Paulo-Guide ansehen',
      viewGuideB: 'Miami-Guide ansehen',
      whyInvestTitle: 'Warum in São Paulo investieren?',
      whyInvestSubtitle: '4 Gründe, die São Paulo zum größten Immobilieninvestitionsziel Lateinamerikas machen.',
      neighborhoodsTitle: 'São Paulo Stadtteile — Vollständige Analyse',
      neighborhoodsSubtitle: 'Klicken Sie auf einen Stadtteil, um detaillierte Preise, Bewertungen und Marktprofil zu sehen.',
      rankingTitle: 'Preisranking — São Paulo Stadtteile',
      rankingSubtitle: 'Vergleich sortiert nach Durchschnittspreis pro m² · 2025',
      faqTitle: 'Fragen zu Immobilien in São Paulo',
      faqSubtitle: 'Die wichtigsten Fragen von Käufern und Investoren zum größten Immobilienmarkt Lateinamerikas.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'Das Top-Ziel für Brasilianer in den USA — starker Dollar, hohe Rendite und internationaler Markt.',
      exploreCardMiamiBadge: 'Florida, USA',
      exploreCardMiamiPrice: '$1.100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'Jährliche Wertsteigerung',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Bundeshauptstadt mit dem höchsten Pro-Kopf-Einkommen Brasiliens, UNESCO-Weltkulturerbe und resilientem Markt.',
      exploreCardBrasiliaBadge: 'Bundesdistrikt',
      exploreCardBrasiliaPrice: 'R$12.000/m²',
      exploreCardBrasiliaYoY: '+12,6%',
      exploreCardBrasiliaYoYLabel: 'Höchster Anstieg des Jahres',
      ctaTitle: 'Bereit, in São Paulo zu investieren?',
      ctaSubtitle: 'Unser auf den Paulistaner Markt spezialisiertes Team begleitet Sie von der Stadtteilauswahl bis zur Vertragsunterzeichnung — ohne zusätzliche Kosten.',
      ctaSecondary: 'Immobilien in São Paulo ansehen',
    },
    brasilia: {
      heroBadge: 'Brasília · Bundesdistrikt',
      heroTitle: 'Beste Stadtteile in Brasília',
      heroTitleHighlight: 'zum Immobilienkauf 2025',
      heroDescription: 'Brasília verzeichnete 2025 ein Wachstum von 12,6% bei den Neubaupreisen — das höchste unter den brasilianischen Hauptstädten. Die Bundeshauptstadt mit einem der höchsten Pro-Kopf-Einkommen Brasiliens, stabiler öffentlicher Nachfrage und durch Denkmalschutz natürlich begrenztem Angebot ist einer der resilientesten Märkte des Landes.',
      heroCtaProperties: 'Immobilien in Brasília ansehen',
      heroCtaContact: 'Mit Berater sprechen',
      location: 'Brasília, DF',
      countryLabel: 'Bundesdistrikt, Brasilien',
      currencyA: 'BRL · Brasilianischer Real',
      currencyB: 'BRL · Brasilianischer Real',
      strengthsA: ['UNESCO-begrenztes Angebot', 'Höchstes Pro-Kopf-Einkommen in BR', 'Stabile öffentliche Nachfrage', 'Krisenresistenter Markt'],
      strengthsB: ['Größter Markt in LATAM', 'Maximale Liquidität', 'Stadtteil- und Preisklassenvielfalt', 'Faria-Lima-Unternehmenszentrum'],
      risksA: ['Regionalere Liquidität', 'Abhängigkeit von Bundesbudgets', 'Weniger diversifizierter Markt'],
      risksB: ['ITBI + hohe Steuerlast', 'Hohes Angebot in einigen Gebieten', 'Allmählichere Wertsteigerung'],
      idealProfileA: 'Konservatives Profil auf der Suche nach Vermögenssicherheit und stabilem Einkommen von Beamten',
      idealProfileB: 'Maximale Liquidität, Stadtteilvielfalt und Zugang zum größten Finanzzentrum Lateinamerikas',
      entryPriceA: 'R$ 450.000',
      entryPriceB: 'R$ 350.000',
      avgPriceA: 'R$ 12.000/m²',
      avgPriceB: 'R$ 11.800/m²',
      topMarketA: 'R$ 16.500/m² · Sudoeste',
      topMarketB: 'R$ 32.000/m² · Cidade Jardim',
      yieldA: '~5% p.a.',
      yieldB: '4–6% p.a.',
      horizonA: '3–7 Jahre',
      horizonB: '3–10 Jahre',
      liquidityA: '7.0',
      liquidityB: '10.0',
      appreciationA: '8.0',
      appreciationB: '7.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '7.0',
      overallScoreA: '7.3',
      overallScoreB: '8.0',
      scoreWidthA: '73%',
      scoreWidthB: '80%',
      viewGuideA: 'Brasília-Guide ansehen',
      viewGuideB: 'São Paulo-Guide ansehen',
      whyInvestTitle: 'Warum in Brasília investieren?',
      whyInvestSubtitle: '4 strukturelle Faktoren, die Brasília zu einem der resilientesten Immobilienmärkte Brasiliens machen.',
      neighborhoodsTitle: 'Brasília Stadtteile — Vollständige Analyse',
      neighborhoodsSubtitle: 'Klicken Sie auf einen Stadtteil, um detaillierte Preise, Bewertungen und Marktprofil zu sehen.',
      rankingTitle: 'Preisranking — Brasília Stadtteile',
      rankingSubtitle: 'Vergleich sortiert nach Durchschnittspreis pro m² · 2025',
      faqTitle: 'Fragen zu Immobilien in Brasília',
      faqSubtitle: 'Die wichtigsten Fragen von Käufern und Investoren zum Immobilienmarkt von Brasília und dem Bundesdistrikt.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'Das Top-Ziel für Brasilianer in den USA — starker Dollar, hohe Rendite und internationaler Markt.',
      exploreCardMiamiBadge: 'Florida, USA',
      exploreCardMiamiPrice: '$1.100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'Jährliche Wertsteigerung',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Größter Immobilienmarkt Lateinamerikas. Faria Lima, Itaim Bibi und der kontinuierliche Wertsteigerungskorridor.',
      exploreCardSPBadge: 'São Paulo, Brasilien',
      exploreCardSPPrice: 'R$11.800/m²',
      exploreCardSPYoY: '+8,7%',
      exploreCardSPYoYLabel: 'Jährliche Wertsteigerung',
      ctaTitle: 'Bereit, in Brasília zu investieren?',
      ctaSubtitle: 'Unser auf den DF-Markt spezialisiertes Team begleitet Sie von der Stadtteilauswahl bis zur Vertragsunterzeichnung — ohne zusätzliche Kosten.',
      ctaSecondary: 'Immobilien in Brasília ansehen',
    },
  },
};

export default guia;